import React, { Fragment } from 'react';
import classNames from 'classnames';
import NavItem from './NavItem';
import NavDropdownMenu from './NavDropdownMenu';

const NavDropdown = (props) => {
  const { label, children, active, navClass } = props;
  let childActive = false;
  const onHover = () => {
    childActive = true;
  };
  const navClasses = classNames('nav-item', 'nav-item-dropdown', navClass);

  return (
    <div className={navClasses}>
      {label}
      <NavDropdownMenu>{children}</NavDropdownMenu>
      {/* <NavItemForMenu onHover={onHover}>{label}</NavItemForMenu> */}
      {/* <DropdownMenu
       active={childActive}
      >
       {children}
     </DropdownMenu> */}
    </div>
  );
};
export default NavDropdown;
